import { BCGMS_API_URL, CROPS, hideLoaderBox, INDICATORS_PARAMS, initCropSelector, initDateSelector, initDecadeSelector, initIndicatorMSSelect, initIndicatorSelect, initMonthSelector, initProviderSelector, initYearSelector, onSelectReferencial, } from "./tools_02";
import { initMap, map } from "./map_02";
import { autorangeChart, initGraphSelectors } from "./graph_02";
/* import css */
import "./css/bcgms.css";
import "./css/indicators.css";
/*
 * init
 */
var init = function () {
    /*  initialisation des HTML events*/
    var referencialInput = document.getElementById("referencialInput");
    referencialInput.addEventListener("change", onSelectReferencial);
    window.onresize = function () {
        /* resize the graph */
        autorangeChart();
        /* FIXME resize the map */
        setTimeout(function () {
            map.updateSize();
        }, 500);
    };
    /* chargement des data */
    fetch("".concat(BCGMS_API_URL, "available-indices/")).then(function (response) {
        return response.json().then(function (available_indices) {
            fetch("".concat(BCGMS_API_URL, "indices/"))
                .then(function (response) { return response.json(); })
                .then(function (data) {
                var max_itera = data.results.length;
                if (max_itera < 1000000) {
                    // transform indicator array in a keyed object
                    for (var i = 0; i < max_itera; i++) {
                        var a = data.results[i];
                        if (available_indices.results.includes(a.code)) {
                            INDICATORS_PARAMS[a.code] = a;
                        }
                    }
                    fetch("".concat(BCGMS_API_URL, "crops/"))
                        .then(function (response) { return response.json(); })
                        .then(function (data) {
                        // transform crop array in a keyed object
                        var max_iterc = data.results.length;
                        if (max_iterc < 1000000) {
                            for (var i = 0; i < max_iterc; i++) {
                                var c = data.results[i];
                                CROPS[c.crop_id] = c;
                            }
                            initProviderSelector();
                            initGraphSelectors();
                            initDateSelector();
                            initYearSelector();
                            initDecadeSelector();
                            initMonthSelector();
                            initCropSelector()
                                .then(initIndicatorMSSelect)
                                .then(initIndicatorSelect)
                                .then(initMap)
                                .then(hideLoaderBox);
                        }
                        else {
                            console.log("Too many crops");
                        }
                    });
                }
                else {
                    console.log("Too many indicators");
                }
            });
        });
    });
};
init();
